
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { StpImporterService } from '../../service/importer-stp.service';
import { Line } from '../../service/line.dto';
import { map } from 'rxjs/operators';
import { isArray } from 'lodash';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'importer-stp-line-selector',
  templateUrl: './line-selector.component.html',
  styleUrls: ['./line-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LineSelectorComponent),
      multi: true
    }
  ]
})
export class LineSelectorComponent implements ControlValueAccessor {
  @Input() type: 'kppId' | 'name' | 'number' = 'name';
  @Input() trimValue: boolean = false;
  @Input() multiple: boolean = true;
  @Output() readonly selectedKppIds: EventEmitter<number[] | null> = new EventEmitter();

  availableLines: AvaliableLine[] = [];
  value: string | number | string[] | number[] | null = null;
  disabled: boolean = false;

  onChange: any = () => { };
  onTouched: any = () => { };

  constructor(private importerService: StpImporterService) { }


  @Input() set carrierId(carrierId: null | number) {
    if (carrierId != null) {
      this.importerService.getAllLines(carrierId)
        .pipe(
          map(v => v.map(l => new AvaliableLine(l.number, this.getOptionValue(l), l.kppId)))
        )
        .subscribe(s => this.availableLines = s);
    } else {
      this.availableLines = [];
      this.onSelectChange(null);
    }
  }

  getOptionValue(item: Line): any {
    const value = this.type ? item[this.type] : item;
    return (this.trimValue === true && typeof value === 'string') ? value.trim() : value;
  }

  writeValue(value: string | number | string[] | number[] | null): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelectChange(value: string | number | string[] | number[] | null): void {
    if (value != null && isArray(value)) {
      const vals = value as any[];
      const kppIds = this.availableLines
        .filter(opt => vals.includes(opt.value))
        .map(v => v.kppId);
      this.selectedKppIds.next(kppIds.length > 0 ? kppIds : null);
    } else if (value != null) {
      const kppId = this.availableLines.find(opt => opt.value === value)?.kppId ?? null;
      this.selectedKppIds.next(kppId != null ? [kppId] : null);
    } else {
      this.selectedKppIds.next(null);
    }
    this.value = value;
    this.onChange(value);
  }
}

class AvaliableLine {
  constructor(public readonly displayValue: string, public readonly value: number | string, public readonly kppId: number) { }
}
